export const formatDate = (dateString: string) => {
  if (!dateString) return '';

  let date: Date;

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{6}Z$/.test(dateString)) {
    // Handle ISO 8601 format
    date = new Date(dateString);
  } else if (/^\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2}$/.test(dateString)) {
    // Handle the custom format 'YYYY-MM-DD-HH-MM-SS'
    const [year, month, day, hour, minute, second] = dateString.split('-').map(Number);
    date = new Date(year, month - 1, day, hour, minute, second);
  } else {
    // Fallback to default Date parsing
    date = new Date(dateString);
  }

  // biome-ignore lint/style/noRestrictedGlobals: <explanation>
  if (isNaN(date.getTime())) {
    console.error('Invalid date:', dateString);
    return 'Invalid Date';
  }

  return new Intl.DateTimeFormat('cs-CZ', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};
